import axios from "axios";
import Vue from "vue";

const getDefaultSelectedInternationalCard = () => {
  return [];
};
const getDefaultCartResponse = () => {
  return {};
};

const getDefaultEurToTryCurrency = () => {
  return null;
};

const getDefaultSelectedOrderPassenger = () => {
  return {};
};
export default {
  state: () => ({
    selectedInternationalCard: getDefaultSelectedInternationalCard(),
    selectedInternationalCardDuplicate: getDefaultSelectedInternationalCard(),
    cartResponse: getDefaultCartResponse(),
    eurToTryCurrency: getDefaultEurToTryCurrency(),
    selectedOrderPassenger: getDefaultSelectedOrderPassenger(),
  }),

  mutations: {
    setSelectedInternationalCard(state, internationalCard) {
      Vue.set(state, "selectedInternationalCard", internationalCard);
    },
    setSelectedInternationalCardDuplicate(state, internationalCardDuplicate) {
      Vue.set(state, "selectedInternationalCardDuplicate", internationalCardDuplicate);
    },
    setDefaultSelectedInternationalCard(state) {
      Vue.set(state, "selectedInternationalCard", getDefaultSelectedInternationalCard());
    },
    setDefaultSelectedInternationalCardDuplicate(state) {
      Vue.set(state, "selectedInternationalCardDuplicate", getDefaultSelectedInternationalCard());
    },
    setCartResponse(state, cartResponse) {
      Vue.set(state, "cartResponse", cartResponse);
    },
    setEurToTryCurrency(state, eurToTryCurrency) {
      Vue.set(state, "eurToTryCurrency", eurToTryCurrency);
    },
    setSelectedOrderPassenger(state, selectedOrderPassenger) {
      Vue.set(state, "selectedOrderPassenger", selectedOrderPassenger);
    },
    setDefaultSelectedOrderPassenger(state) {
      Vue.set(state, "selectedOrderPassenger", getDefaultSelectedOrderPassenger());
    },
    setDefaultEurToTryCurrency(state) {
      Vue.set(state, "eurToTryCurrency", getDefaultEurToTryCurrency());
    },
    setDefaultCartResponse(state) {
      Vue.set(state, "cartResponse", getDefaultCartResponse());
    },
  },

  actions: {
    loadEurailCountries: (context) => {
      return axios
        .get(context.getters.getPoolExternalUrl + "/pex/eurail/countries")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadEurailOneCountryPassNames: (context) => {
      return axios
        .get(context.getters.getPoolExternalUrl + "/pex/eurail/one-country-pass-names")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadEurailSearch: (context, request) => {
      return axios
        .post(context.getters.getPoolExternalUrl + "/pex/eurail/search", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadEurailCalculate: (context, request) => {
      return axios
        .post(context.getters.getPoolExternalUrl + "/pex/eurail/calculate", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    postEurailCarts: (context, request) => {
      return axios
        .post(context.getters.getPoolExternalUrl + "/pex/eurail/carts", request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    postOrder: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/eurail/orders", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadEurailOrdersSearch: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/eurail/orders/search", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadEurailOrderStatus: (context, orderNumber) => {
      return axios
        .get(context.getters.getCrsServiceUrl + "/eurail/orders/" + encodeURIComponent(orderNumber) + "/status")
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadEurailOrdersId: (context, request) => {
      return axios
        .get(context.getters.getCrsServiceUrl + "/eurail/orders/" + request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadEurailRefundReasons: (context) => {
      return axios
        .get(context.getters.getPoolExternalUrl + "/pex/eurail/refund-reasons")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadEurailOrderStates: (context) => {
      return axios
        .get(context.getters.getPoolExternalUrl + "/pex/eurail/order-states")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadEurailRefundablesOrderId: (context, request) => {
      return axios
        .get(context.getters.getPoolExternalUrl + "/pex/eurail/refundables/" + request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadEurailPassStates: (context) => {
      return axios
        .get(context.getters.getPoolExternalUrl + "/pex/eurail/pass-states")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    EurailOrdersRefund: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/eurail/orders/refund", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    createEurailOrdersMailResend: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/eurail/orders/mail-resend", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    createInternationalSettelementExport: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/international-settlement/export", request, {
          responseType: "blob",
        })
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
  },
  getters: {
    getSelectedInternationalCard: (state) => {
      return state.selectedInternationalCard;
    },
    getSelectedInternationalCardDuplicate: (state) => {
      return state.selectedInternationalCardDuplicate;
    },
    getCartResponse: (state) => {
      return state.cartResponse;
    },
    getEurToTryCurrency: (state) => {
      return state.eurToTryCurrency;
    },
    getSelectedOrderPassenger: (state) => {
      return state.selectedOrderPassenger;
    },
    getDefaultSelectedInternationalCard: (state) => {
      return getDefaultSelectedInternationalCard();
    },
    getDefaultCartResponse: (state) => {
      return getDefaultCartResponse();
    },
    getDefaultSelectedInternationalCardDuplicate: (state) => {
      return getDefaultSelectedInternationalCard();
    },
    getDefaultSelectedOrderPassenger: (state) => {
      return getDefaultSelectedOrderPassenger();
    },
  },
};
